import * as React from 'react';

export default () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 12L17 12" stroke="#0067F4" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 7.00508L12 16.9949" stroke="#0067F4" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
